import appApi from "@/app/api";
import { PAYMENT_V2_ENDPOINT_V1 } from "@/components/Pricing/v2/constants.pricing";
import { TProductRefId } from "@/types/plan";

const APIURL = `${PAYMENT_V2_ENDPOINT_V1}/subscription/resume`;

export interface ResumePlanPayload {
  products_to_resume: TProductRefId[];
}

export interface ResumePlanData {
  message: string;
  resume_timestamp: number;
  success: boolean;
}

// type TResponse = TCloudAPIResponse<ResumePlanData>;

interface ResumePlanOption {
  token: string;
  resumingPlanIds: TProductRefId[];
}

export async function handleResumePlan(
  option: ResumePlanOption,
): Promise<ResumePlanData> {
  const headers = {
    Authorization: "Bearer " + option.token,
    "Content-Type": "application/json",
  };

  try {
    const response = await appApi.post(
      APIURL,
      {
        products_to_resume: option.resumingPlanIds,
      },
      {
        headers,
      },
    );

    const res = response.data as ResumePlanData;

    return res;
  } catch (error: any) {
    console.error("Error resuming plan:", error);
    throw error;
  }
}
